import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { Envelope } from '../../../../types';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../../constants/signatureBasePath';
import { getEnvelope } from '../../requests/getEnvelope';

export const useSignatureEnvelope = (
  envelopeId: string,
  params?: RequestConfig['params'],
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, ...rest } = useQuery<
    NonPaginatedResponse<Envelope> | undefined
  >({
    queryKey: [SIGNATURE_BASE_PATH, 'envelope', envelopeId, params],
    queryFn: () => getEnvelope(constructGet, envelopeId, params),
    staleTime: 10000,
    ...options,
  });

  return { envelope: data?.data, ...rest };
};
